const ROLE_PERMISSION_FALLBACK = {
  platform_admin: ['*'],
  psychologist_manager: [
    'padmin.dashboard.view',
    'padmin.analytics.view',
    'padmin.alerts.view',
    'padmin.students.view',
    'padmin.students.import',
    'padmin.students.update',
    'padmin.students.archive',
    'padmin.students.bulk_archive',
    'padmin.students.delete',
    'padmin.passport.view',
    'padmin.passport.manage',
    'padmin.tests.manage',
    'padmin.settings.view'
  ],
  psychologist_operator: [
    'padmin.dashboard.view',
    'padmin.analytics.view',
    'padmin.alerts.view',
    'padmin.students.view',
    'padmin.passport.view'
  ],
  test_manager: ['test.*'],
  test_observer: ['test.dashboard.view', 'test.groups.view', 'test.monitor.view', 'test.results.view', 'test.students.view']
};

const normalizePermissions = permissions =>
  Array.isArray(permissions)
    ? permissions
        .map(permission => String(permission || '').trim())
        .filter(Boolean)
    : [];

const getRoleFallbackPermissions = source => {
  const role = String(source?.role || '').trim();
  return normalizePermissions(ROLE_PERMISSION_FALLBACK[role] || []);
};

export const permissionMatches = (grantedPermission, requiredPermission) => {
  if (!requiredPermission) {
    return true;
  }

  if (grantedPermission === '*' || grantedPermission === requiredPermission) {
    return true;
  }

  if (typeof grantedPermission === 'string' && grantedPermission.endsWith('.*')) {
    return String(requiredPermission || '').startsWith(grantedPermission.slice(0, -1));
  }

  return false;
};

export const hasPermission = (source, requiredPermission) => {
  if (!requiredPermission) {
    return true;
  }

  const directPermissions = normalizePermissions(Array.isArray(source) ? source : source?.permissions);
  const permissions = directPermissions.length > 0 ? directPermissions : getRoleFallbackPermissions(source);

  return permissions.some(grantedPermission => permissionMatches(grantedPermission, requiredPermission));
};

export const filterRoutesByPermissions = (routes, source) => {
  const items = Array.isArray(routes) ? routes : [];

  return items.reduce((visibleRoutes, route) => {
    if (!route || !hasPermission(source, route.permission)) {
      return visibleRoutes;
    }

    const children = Array.isArray(route.children) ? filterRoutesByPermissions(route.children, source) : [];
    const nextRoute = children.length > 0 ? { ...route, children } : { ...route };

    if (!nextRoute.to && !nextRoute.href && children.length === 0) {
      return visibleRoutes;
    }

    visibleRoutes.push(nextRoute);
    return visibleRoutes;
  }, []);
};
